// extracted by mini-css-extract-plugin
module.exports = {"container":"App_container__1L44H","image":"App_image__C2xjK"};